// Mock data - will be replaced by DynamoDB calls later

export const COMPETITIONS = {
  PREMIER_LEAGUE: { id: 'pl', name: 'Premier League', emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', color: '#3d195b' },
  CHAMPIONS_LEAGUE: { id: 'cl', name: 'Champions League', emoji: '🌟', color: '#091442' },
  WORLD_CUP: { id: 'wc', name: 'World Cup', emoji: '🏆', color: '#56042c' },
  EUROS: { id: 'eu', name: 'Euros', emoji: '🇪🇺', color: '#003399' },
  SPECIAL: { id: 'sp', name: 'Special Events', emoji: '🎲', color: '#ff6b35' },
};

export const MARKET_TYPES = {
  MATCH_RESULT: { id: 'match_result', name: 'Match Result', description: 'Home / Draw / Away', icon: '⚽' },
  BOTH_TEAMS_SCORE: { id: 'both_teams_score', name: 'Both Teams to Score', description: 'Yes / No', icon: '🥅' },
  OVER_UNDER_GOALS: { id: 'over_under_goals', name: 'Over/Under Goals', description: 'Over or Under 2.5 goals', icon: '🔢' },
  YELLOW_CARDS: { id: 'yellow_cards', name: 'Yellow Cards', description: 'Over/Under total yellows', icon: '🟨' },
  RED_CARDS: { id: 'red_cards', name: 'Red Card in Match', description: 'Will there be a red?', icon: '🟥' },
  CORNERS: { id: 'corners', name: 'Total Corners', description: 'Over/Under corners', icon: '📐' },
  FIRST_GOAL: { id: 'first_goal', name: 'First Goalscorer', description: 'Who scores first?', icon: '🥇' },
  HALFTIME_RESULT: { id: 'halftime_result', name: 'Half-Time Result', description: 'HT score prediction', icon: '⏱️' },
  EXACT_SCORE: { id: 'exact_score', name: 'Exact Score', description: 'Predict the final score', icon: '🎯' },
  ANYTIME_SCORER: { id: 'anytime_scorer', name: 'Anytime Goalscorer', description: 'Scores at any point', icon: '💥' },
  CLEAN_SHEET: { id: 'clean_sheet', name: 'Clean Sheet', description: 'Will a team keep a clean sheet?', icon: '🧤' },
  UNORTHODOX: { id: 'unorthodox', name: 'Unorthodox Bet', description: 'Weird & wonderful markets', icon: '🤪' },
};

export const PLAYER_ARCHETYPES = {
  BOLD: {
    id: 'bold',
    label: 'The Maverick',
    icon: '🔥',
    sound: 'YOLO King',
    description: 'Loves high-risk, high-reward bets',
    color: '#ff4444',
    criteria: { avgOdds: 4.0, minBets: 3 },
  },
  BORING: {
    id: 'boring',
    label: 'The Accountant',
    icon: '🧮',
    sound: 'Mr. Safe Hands',
    description: 'Only bets on favorites, snooze fest',
    color: '#888888',
    criteria: { avgOdds: 1.8, minBets: 3 },
  },
  ALL_IN: {
    id: 'all_in',
    label: 'The Degen',
    icon: '🎰',
    sound: 'Send It Steve',
    description: 'Puts everything on one bet',
    color: '#9b59b6',
    criteria: { maxBetRatio: 0.5, minBets: 1 },
  },
  CAREFUL: {
    id: 'careful',
    label: 'The Analyst',
    icon: '🧠',
    sound: 'Spreadsheet Sam',
    description: 'Small bets, well diversified',
    color: '#3498db',
    criteria: { avgBetRatio: 0.1, minBets: 5 },
  },
  LUCKY: {
    id: 'lucky',
    label: 'The Jammy Dodger',
    icon: '🍀',
    sound: 'Lucky Larry',
    description: 'Wins bets they have no business winning',
    color: '#2ecc71',
    criteria: { winRate: 0.6, minBets: 3 },
  },
  CONTRARIAN: {
    id: 'contrarian',
    label: 'The Hipster',
    icon: '🎭',
    sound: 'Against-the-Grain Gary',
    description: 'Always bets against the crowd',
    color: '#e67e22',
    criteria: { popularPick: false, minBets: 3 },
  },
};

export const AVATARS = ['😎', '🤠', '🧐', '😤', '🤑', '🦊', '🐺', '🦁', '🐸', '🤖', '👻', '🎃', '🧙', '🥷', '🦸'];

export const ACTIVITY_IMAGES = [
  // Sports & Activities
  { id: 'football', emoji: '⚽', label: 'Football' },
  { id: 'basketball', emoji: '🏀', label: 'Basketball' },
  { id: 'tennis', emoji: '🎾', label: 'Tennis' },
  { id: 'golf', emoji: '⛳', label: 'Golf' },
  { id: 'swimming', emoji: '🏊', label: 'Swimming' },
  { id: 'surfing', emoji: '🏄', label: 'Surfing' },
  { id: 'skiing', emoji: '⛷️', label: 'Skiing' },
  { id: 'cycling', emoji: '🚴', label: 'Cycling' },
  { id: 'running', emoji: '🏃', label: 'Running' },
  { id: 'hiking', emoji: '🥾', label: 'Hiking' },
  { id: 'sports', emoji: '🏆', label: 'Sports' },
  { id: 'bowling', emoji: '🎳', label: 'Bowling' },
  { id: 'darts', emoji: '🎯', label: 'Darts' },
  { id: 'pool', emoji: '🎱', label: 'Pool' },
  // Food & Drink
  { id: 'dinner', emoji: '🍽️', label: 'Dinner' },
  { id: 'drinks', emoji: '🍻', label: 'Drinks' },
  { id: 'cocktails', emoji: '🍸', label: 'Cocktails' },
  { id: 'wine', emoji: '🍷', label: 'Wine' },
  { id: 'coffee', emoji: '☕', label: 'Coffee' },
  { id: 'bbq', emoji: '🍖', label: 'BBQ' },
  { id: 'pizza', emoji: '🍕', label: 'Pizza' },
  { id: 'breakfast', emoji: '🥐', label: 'Breakfast' },
  { id: 'sushi', emoji: '🍣', label: 'Sushi' },
  { id: 'icecream', emoji: '🍦', label: 'Ice Cream' },
  // Entertainment
  { id: 'party', emoji: '🎉', label: 'Party' },
  { id: 'casino', emoji: '🎰', label: 'Casino' },
  { id: 'gaming', emoji: '🎮', label: 'Gaming' },
  { id: 'quiz', emoji: '🧠', label: 'Quiz' },
  { id: 'music', emoji: '🎵', label: 'Music' },
  { id: 'concert', emoji: '🎤', label: 'Concert' },
  { id: 'movie', emoji: '🎬', label: 'Movie' },
  { id: 'theater', emoji: '🎭', label: 'Theater' },
  { id: 'art', emoji: '🎨', label: 'Art' },
  { id: 'karaoke', emoji: '🎙️', label: 'Karaoke' },
  { id: 'fireworks', emoji: '🎆', label: 'Fireworks' },
  // Travel & Places
  { id: 'travel', emoji: '✈️', label: 'Travel' },
  { id: 'beach', emoji: '🏖️', label: 'Beach' },
  { id: 'mountain', emoji: '🏔️', label: 'Mountain' },
  { id: 'camping', emoji: '⛺', label: 'Camping' },
  { id: 'city', emoji: '🏙️', label: 'City' },
  { id: 'museum', emoji: '🏛️', label: 'Museum' },
  { id: 'church', emoji: '⛪', label: 'Church' },
  { id: 'castle', emoji: '🏰', label: 'Castle' },
  { id: 'island', emoji: '🏝️', label: 'Island' },
  { id: 'sunset', emoji: '🌅', label: 'Sunset' },
  // Transport
  { id: 'train', emoji: '🚆', label: 'Train' },
  { id: 'flight', emoji: '✈️', label: 'Flight' },
  { id: 'car', emoji: '🚗', label: 'Car' },
  { id: 'boat', emoji: '⛵', label: 'Boat' },
  { id: 'bus', emoji: '🚌', label: 'Bus' },
  { id: 'taxi', emoji: '🚕', label: 'Taxi' },
  // Accommodation
  { id: 'hotel', emoji: '🏨', label: 'Hotel' },
  { id: 'hostel', emoji: '🛏️', label: 'Hostel' },
  { id: 'house', emoji: '🏠', label: 'House' },
  { id: 'resort', emoji: '🏖️', label: 'Resort' },
  // Misc
  { id: 'shopping', emoji: '🛍️', label: 'Shopping' },
  { id: 'spa', emoji: '💆', label: 'Spa' },
  { id: 'photo', emoji: '📸', label: 'Photo' },
  { id: 'meeting', emoji: '📋', label: 'Meeting' },
  { id: 'celebration', emoji: '🥳', label: 'Celebration' },
  { id: 'heart', emoji: '❤️', label: 'Love' },
  { id: 'star', emoji: '⭐', label: 'Star' },
  { id: 'fire', emoji: '🔥', label: 'Fire' },
  { id: 'lightning', emoji: '⚡', label: 'Lightning' },
  { id: 'crown', emoji: '👑', label: 'Crown' },
];
